import { createSlice } from "@reduxjs/toolkit";
import { deleteStorage } from "../helper/global";
import { LOCAL_STORAGE_KEY } from "../helper/constant";

const userSlice = createSlice({
    name: "user",
    initialState: {
        profile: null,
        sessionToken: null,
        loading: false,
        error: null,
    },
    reducers: {
        resetUserProfile: (state) => {
            state.profile = null;
            state.loading = false;
            state.error = null;
            state.sessionToken = null;

            deleteStorage(LOCAL_STORAGE_KEY.token);
        },
        setUserProfile: (state, action) => {
            state.profile = action.payload.profile;
            state.sessionToken = action.payload.sessionToken;
        },
        setSessionToken: (state, action) => {
            state.sessionToken = action.payload;
        },
    },
});

export const { resetUserProfile, setUserProfile, setSessionToken } =
    userSlice.actions;

export default userSlice.reducer;
